// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-modules-Header-HeaderNav-NavItemWithTitle-style----general-module---container---2iwkS paddingBottom-xs","title":"src-components-modules-Header-HeaderNav-NavItemWithTitle-style----general-module---title---3sExv c-licorice marginBottom-xxs fontWeight-6","description":"src-components-modules-Header-HeaderNav-NavItemWithTitle-style----general-module---description---3eVfS c-slate fontSize-s"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Header/HeaderNav/NavItemWithTitle/style/general.module.css
// module id = 1461
// module chunks = 168707334958949